/**
 * Buyer vs Renter wording for an inspection.
 *
 * An open home on a rental listing is attended by RENTERS, not buyers, so every
 * "Add Buyer" / "Buyer Details" / "Buyer Info" label on the inspection screens
 * reads wrong to the agent standing at the door of a lease property, and
 * "Contract Requested" has no meaning at all there (Monday 12908244171).
 *
 * The property's transaction_type is the source of truth: 'lease' is a rental.
 * 'both' keeps the sale wording, because those listings are still sold.
 * The field arrives on the inspection as property_transaction_type
 * (InspectionSerializer). Anything missing or unrecognised falls back to the
 * sale wording, so an older backend deployment - or a cached list response
 * served from before the field existed - just behaves exactly as it did before.
 */
export const isRentalInspection = (inspection) => {
  const type = (
    inspection?.property_transaction_type
    || inspection?.property?.transaction_type
    || ''
  );
  return String(type).toLowerCase() === 'lease';
};

export const inspectionTerms = (inspection) => {
  const rental = isRentalInspection(inspection);
  return {
    isRental: rental,
    // "Renter" / "Buyer"
    noun: rental ? 'Renter' : 'Buyer',
    nounLower: rental ? 'renter' : 'buyer',
    nounPlural: rental ? 'Renters' : 'Buyers',
    nounPluralLower: rental ? 'renters' : 'buyers',
    addLabel: rental ? 'Add Renter' : 'Add Buyer',
    // A rental attendee never asks for a contract of sale.
    showContractRequested: !rental,
    // The same editor either way, but "Buying Preferences" reads wrong to
    // someone who is renting.
    prefsLabel: rental ? 'Preferences' : 'Buying Preferences',
  };
};

export default inspectionTerms;
